import { render, staticRenderFns } from "./WaiBuGongShi6.vue?vue&type=template&id=1ecd9de7&scoped=true&"
import script from "./WaiBuGongShi6.vue?vue&type=script&lang=js&"
export * from "./WaiBuGongShi6.vue?vue&type=script&lang=js&"
import style0 from "./WaiBuGongShi6.vue?vue&type=style&index=0&id=1ecd9de7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd9de7",
  null
  
)

export default component.exports